/* eslint-disable no-undef */
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    bookingId: String,
    brand: String,
    productName: String,
    productSkuName: String,
    gaClientId: String,
    gaSessionId: String,
    gclid: String,
    wbraid: String,
    gbraid: String,
    fbp: String,
    fbc: String,
    fbclid: String,
    eventId: String,
  };

  connect() {
    this.retryCounter = 0;
    this.tagBooking();
  }

  tagBooking() {
    if (this.retryCounter < 20) {
      this.retryCounter += 1;
      try {
        if (gtag) {
          const eventData = {
            item_id: this.bookingIdValue,
            item_brand: this.brandValue,
            item_category: this.productNameValue,
            item_category2: this.productSkuNameValue,
          };

          // Add tracking parameters if present
          if (this.gaClientIdValue) eventData.client_id = this.gaClientIdValue;
          if (this.gaSessionIdValue)
            eventData.session_id = this.gaSessionIdValue;
          if (this.gclidValue) eventData.gclid = this.gclidValue;
          if (this.wbraidValue) eventData.wbraid = this.wbraidValue;
          if (this.gbraidValue) eventData.gbraid = this.gbraidValue;
          if (this.fbpValue) eventData.fbp = this.fbpValue;
          if (this.fbcValue) eventData.fbc = this.fbcValue;
          if (this.fbclidValue) eventData.fbclid = this.fbclidValue;
          if (this.eventIdValue) eventData.event_id = this.eventIdValue;

          gtag("event", "booking", eventData);
        } else {
          setTimeout(() => this.tagBooking(), 200);
        }
      } catch (_e) {
        setTimeout(() => this.tagBooking(), 200);
      }
    }
  }
}
